import { render } from "./TabMenuManager.vue?vue&type=template&id=53fc382a&scoped=true"
import script from "./TabMenuManager.vue?vue&type=script&lang=js"
export * from "./TabMenuManager.vue?vue&type=script&lang=js"

import "./TabMenuManager.vue?vue&type=style&index=0&id=53fc382a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53fc382a"]])

export default __exports__